export default {
  product: 'course1',
  title: 'Course #1',
  apiProdUrl: 'https://course1.uno:9999/api',
  apiDevUrl: 'http://localhost:8621/api',
  botProdUsername: 'coursenumberone_bot',
  botDevUsername: 'courseonedev_bot',
}